module.exports = __webpack_public_path__ + "static/media/happy.2ced1bd8.svg";